import React from 'react';

import * as S from './GfpOffer.styled';

type IProps = {
  icon: React.ReactNode;
  title: string;
  value: string | number | React.ReactNode;
  tag?: boolean;
};

export default function GfpOfferDetails(props: IProps) {
  const { icon, title, value, tag } = props;

  return (
    <S.InfoContainer>
      <S.InfoIconContainer>{icon}</S.InfoIconContainer>
      <S.InfoDescriptionContainer>
        <S.InfoTitle>{title}</S.InfoTitle>
        {tag ? <S.Tag>{value}</S.Tag> : <S.InfoValue>{value}</S.InfoValue>}
      </S.InfoDescriptionContainer>
    </S.InfoContainer>
  );
}
